import React, { useState } from 'react';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import HeaderComponent from '../../components/header'
import TermsAndConditions from '../../components/cdr/TermsAndConditionsModal';
import { useDispatch, useSelector } from 'react-redux';
import { useMutation, useQuery } from 'react-query';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import Loadingcomponent from '../../components/loader/loadingcomponent';
import { GetCacheKey, consoleLog, getItemOfSessionStorage } from '../../services/common/utils';
import { callQueryapi } from '../../services/http/callapi';
import Countdown from 'react-countdown';
import MessageModal from '../../components/common/bottom-modal-message';
import { IS_2FA_DONE } from '../../services/common/Constants';
import SupportModal from '../more/SupportModal';
import { CDR_SEND_OTP, CDR_VALIDATE_OTP } from '../../services/common/endpoints';
import { setToastData } from '../../reducer/utilitySlice';
import { GTM_OtpValidation } from '../../analytics/GoogleTagManager';
import { CT_Events } from '../../analytics/CTEvents';

const VerificationOTP = ({setRadioCheck, cdrResponse}) => {
  const [show, setShow] = useState(false);
  const { t } = useTranslation();
  const selectedMsisdn = useSelector((state) => state?.userdata?.value?.selectedmsisdn);
  const [otpValue, setOtpValue] = useState("");
  const [errorMessage, setErrorMessage] = useState(null);
  const [disabled, setDisabled] = useState(false);
  const [transid, setTransid] = useState('');
  const [countdown, setCountDown] = useState(Date.now() + 42000);
  const [countdownIndex, setCountdownIndex] = useState(1);
  const [countDownView, setShowCountDownView] = useState(false);
  const dispatch = useDispatch();
  const msisdn = useSelector((state) => state?.userdata?.value?.selectedmsisdn);
  const { CT_OtpVerification } = CT_Events();
  const [showVerificationSuccess, setShowVerificationSuccess] = useState(false);
  const sendotp = useQuery(["", CDR_SEND_OTP,
    {
      type: "sms",
      msisdn: `965${selectedMsisdn}`,
      // action: "auth"
    },
    {}, false, 'cdr'], {
    retry: false,
    retryOnMount: false,
    onSuccess: (res) => {
      if (res?.data?.status == "0") {
        dispatch(setToastData({
          show: true,
          message: res?.data?.message,
          icon: ''
        }));
        if (res?.data?.response) {
          setErrorMessage('')
          setTransid(res?.data?.response?.transid);
          setCountDown(Date.now() + 42000); //count down timer
          setCountdownIndex(countdownIndex + 1);
          setShowCountDownView(true);

        } else {
          setErrorMessage(res?.data?.message)
          return false;
        }
      } else {
        setErrorMessage(res?.data?.message)
        return false;
      }
    },
    onerror: (err) => {
      consoleLog(err);
      return false;
    },
  });

  const validateOtp = useMutation(
    (req) => callQueryapi({
      queryKey: [{}, CDR_VALIDATE_OTP,
      {
        transid: transid,//otp entered by user
        otp: otpValue, //tranid from sendotp api response
        type: "sms",
      }, {}, false, 'cdr']
    }),
    {
      retry: false,
      retryOnMount: false,
      enabled: false,
      onSuccess: (res) => {
        if (res?.data?.status === "0") {
          // navigate("/verification-paci", { //navigate to second step of verification 
          //     state: { tid: transid },
          //   })
          setTimeout(()=>{
            setRadioCheck(cdrResponse?.verificationconfigurations?.step_2)   
          }, [1500])
         setShowVerificationSuccess( true );
         
        } else if (res?.data?.status === "-1") {
          setErrorMessage(res?.data?.message)
        }
        try{
          GTM_OtpValidation("otp_login", msisdn, "msisdn",  res?.data?.message);
          CT_OtpVerification(msisdn);
        }catch{}
      }
    });
  const handleToggle = () => {
    setShow(!show);
  }
  const otpChange = (e) => {
    if (e?.target?.value.length <= 4 && e?.target?.value?.match(/^[0-9]*$/)) {
      setOtpValue(e?.target?.value);
      setErrorMessage('')
    }
    if (e?.target?.value?.length < 4) {
      setErrorMessage('')
    } 
  };
  const resendclick = () => {
    setErrorMessage('');
    setOtpValue('');
    sendotp.refetch()
  }
  const submitOtp = () => {
    if (errorMessage === "" && otpValue?.length === 4) {
      validateOtp.mutate()
    }
  }
  const countdownCompleted = () => {
    setShowCountDownView(false)
  };
  const countdownRenderer = ({ hours, minutes, seconds, completed }) => {

    if (completed) {
      // setResendEnable(true);

      countdownCompleted();

      // Render a completed state

      return "";
    } else {
      // Render a countdown

      return (
        <span>
          {minutes}.{seconds > 9 ? seconds : `0${seconds}`} S
        </span>
      );
    }
  };
  // const handleCheck = (check) =>{
  //   if(check === "checked"){
  //     setTandC_Check(true);
  //   }else{
  //     setTandC_Check(false)
  //   }
  // }

  return (
    <div className='sprint17-verification-conent sprint17_white_bg'>
       <div className="sprint17-verifi-sec02">
        <div>
              <div className='sprint17-form-row'>
                <div className='sprint17-ver001'>
                  <h5>{cdrResponse?.otpverificationconfigurations?.title}</h5>
                  <p>{cdrResponse?.otpverificationconfigurations?.desc} </p>
                </div>
                <div className='sprint17-mnumber'>
                  <h5>{selectedMsisdn}</h5>
                </div>
              </div> 
              <div style={{height: "40px"}}>{(sendotp?.isLoading || sendotp?.isFetching  ) && <Loadingcomponent width={33}/>  }</div>

              <div className={`sprint17-text-field }`}>
                <Form.Group as={Col} md="12" controlId="validationCustom02" className='sprint16-form-control'>
                  {/* <Form.Label>Enter Code</Form.Label> */}
                  <Form.Control
                    type="password"
                    className="form-control"
                    placeholder=""
                    inputMode="numeric"
                    value={otpValue}
                    onChange={otpChange}
                    maxLength={4}
                  />
                </Form.Group>
                {errorMessage && <p className="text-danger mt-1 mb-0 w-100 error_msg"> {errorMessage}</p>}
                <div className='sprint17-resendotp'>
                  <div className='resend-btn w-50'>
                    <a
                      className={`hyperlink hyperlink_sm ${(!countDownView && !(sendotp.isLoading || sendotp?.isFetching) && !(validateOtp.isLoading || validateOtp?.isFetching)) ? "enabled" : "disabled"
                        }`}
                      onClick={() => !countDownView && resendclick()}> {cdrResponse?.otpverificationconfigurations?.resend_otp_text}</a>
                  </div>
                  {countDownView &&
                    <div className='resend-timer'>
                      <Countdown
                        key={countdownIndex}
                        date={countdown}
                        renderer={countdownRenderer}
                      ></Countdown>
                    </div>
                  }

                  {/* <div className='resend-timer'>0.40 S</div> */}
                </div>
              </div>
              </div>

              <div className='sprint17-tandc'>
                <p style={{color: cdrResponse?.verificationconfigurations?.access_info_color}}>
                  {cdrResponse?.verificationconfigurations?.access_info_text}
                </p>
                <div>
                  <a onClick={() => setShow(!show)} handleToggle={handleToggle}>{cdrResponse?.verificationconfigurations?.tnc_link_text}</a>
                </div>
              </div>
              <section class="fixed_footer">
                <div class="fixed_footer_container">
                  <button 
                    class={`custom_btn custom_btn_primary btn_block sp16_custom_btn ${(otpValue?.length < 4 || validateOtp?.isLoading || errorMessage) && 'disabled'}`} 
                    disabled={(otpValue?.length < 4) } 
                    onClick={disabled || validateOtp?.isLoading ? () => {} : submitOtp} >{cdrResponse?.otpverificationconfigurations?.button_text}
                  </button>
                  </div>
              </section>
            </div>

      {/* <TermsAndConditions show={show} toggleModal={handleToggle} handleCheck={handleCheck}/> */}
      {show && <SupportModal show={show} toggleModal={handleToggle} segmentId={cdrResponse?.commonconfigurations?.otp_terms_segmentid}/>}
      <MessageModal type='verification-successfull' show={showVerificationSuccess} setShowVerificationSuccess={setShowVerificationSuccess}/>
    </div>
  )
}

export default VerificationOTP; 